module.exports = __webpack_public_path__ + "static/media/rango-fotoFrente.ba4b7c3e.jpg";